import {
  Button,
  ButtonTypeMap,
  ClickAwayListener,
  Popper,
  PopperPlacementType,
  Tooltip,
} from '@mui/material';
import fonts from 'styles/typography.module.css';
import * as React from 'react';
import { useOpen } from 'common/hooks/open';

type RequestOpen = React.Dispatch<React.SetStateAction<boolean>>;

interface Props {
  label: React.ReactNode;
  children: React.ReactNode;
  variant?: ButtonTypeMap['props']['variant'];
  className?: string;
  endIcon?: React.ReactNode;
  isOpen?: boolean;
  placement?: PopperPlacementType;
  onRequestOpen?: RequestOpen;
  disabled?: boolean;
  tooltip?: React.ReactNode;
}

export const DropdownButton: React.FC<Props> = (props) => {
  const { label, children, variant, className, endIcon, isOpen, onRequestOpen, disabled, tooltip } =
    props;

  const { anchorElRef, setOpen, open } = useOpen(isOpen, onRequestOpen);

  const button = tooltip ? (
    <Tooltip title={tooltip} classes={{ tooltip: `bg-gray-600 text-white p-3 ${fonts.font}` }}>
      <div>
        <Button
          variant={variant || 'outlined'}
          endIcon={endIcon}
          onClick={() => setOpen((o) => !o)}
          ref={anchorElRef}
          className={` ${disabled ? '' : 'hover:underline'} ${className}`}
          style={{ minWidth: 0 }}
          disabled={disabled}
        >
          {label}
        </Button>
      </div>
    </Tooltip>
  ) : (
    <Button
      variant={variant || 'outlined'}
      endIcon={endIcon}
      onClick={() => setOpen((o) => !o)}
      ref={anchorElRef}
      className={` ${disabled ? '' : 'hover:underline'} ${className}`}
      style={{ minWidth: 0 }}
      disabled={disabled}
    >
      {label}
    </Button>
  );

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div>
        {button}
        <Popper
          open={open && !disabled}
          anchorEl={anchorElRef.current}
          style={{ zIndex: 1110 }}
          // Because we want the action prompts to remain after closing this dropdown
          keepMounted
          placement={props.placement}
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 4],
              },
            },
          ]}
          className="shadow-md"
        >
          {/* <span className={classes.arrow} ref={setArrowRef} /> */}
          <div className="p-2 bg-white border border-blue-900 rounded-sm relative">{children}</div>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
DropdownButton.displayName = 'ContainerActions.DropdownButton';
